import type { InjectionKey, Ref } from 'vue'

import type { AppearanceTab } from './webappPageTabs'

export interface PreviewZoneState {
  zone: Ref<AppearanceTab>
  activeBlock: Ref<string | null>
}

export const PREVIEW_ZONE_KEY: InjectionKey<PreviewZoneState> = Symbol('previewZone')

export const PREVIEW_ZONE_ATTRIBUTE = 'data-preview-zone'
